<template>
    <div id="cartOverlay">
        <span class="delete is-pulled-right has-background-grey" @click="$emit('close')"></span>
        <cart ref="theCart"></cart>
        <button class="button is-warning is-small is-pulled-right top10" @click="checkout" :disabled="$root.cartContents.length == 0">Checkout</button>
    </div>
</template>

<script>
import Cart from './Cart.vue'
export default {
  components: {
    Cart
  },
  methods: {
    checkout: function () {
      this.$router.push('/checkout')
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cartOverlay.vue